import clsx from 'clsx';

import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';
import { twMerge } from 'tailwind-merge';

interface SkeletonChipsProps {
  count?: number;
  className?: string;
}

export function SkeletonChips(props: SkeletonChipsProps) {
  const { count = 4, className } = props;

  return (
    <div className={clsx('flex items-center gap-2')}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonBlock
          key={i}
          className={twMerge(`h-[34px] w-[100px] shrink-0 rounded-[24px]`, className)}
          variant="foreground"
        />
      ))}
    </div>
  );
}
